class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (window.innerWidth < 750) return;
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

/* ═══════════════════════════════════════════════════
   NEWSLETTER FORM → KLAVIYO INTERCEPT
   Catches popup + footer newsletter forms and routes
   to Klaviyo list Y5wyY9 instead of Shopify native form.
   ═══════════════════════════════════════════════════ */
document.addEventListener("submit", function (e) {
  var form = e.target;
  if (!form.classList.contains("newsletter-form") && !form.classList.contains("js-form")) return;
  // Only intercept forms inside newsletter-popup or footer
  var isPopup = form.closest("newsletter-popup");
  var isFooter = form.closest(".footer") || form.closest("[class*='footer']");
  if (!isPopup && !isFooter) return;

  e.preventDefault();

  var emailInput = form.querySelector('input[type="email"]');
  var email = emailInput ? emailInput.value.trim() : "";
  if (!email) return;

  var submitBtn = form.querySelector('button[type="submit"]');
  var messageEl = form.querySelector("[data-message]");
  if (submitBtn) submitBtn.disabled = true;

  // Fire custom event to trigger welcome flow (works for new + existing subscribers)
  fetch("https://a.klaviyo.com/client/events/?company_id=WrKW86", {
    method: "POST",
    headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
    body: JSON.stringify({
      data: {
        type: "event",
        attributes: {
          metric: { data: { type: "metric", attributes: { name: "Newsletter Signup" } } },
          profile: { data: { type: "profile", attributes: { email: email } } },
          properties: { source: isPopup ? "Newsletter Popup" : "Footer Newsletter" }
        }
      }
    })
  }).catch(function (e) { console.warn("[Newsletter] Event error:", e); });

  // Subscribe to Klaviyo list
  fetch("https://a.klaviyo.com/client/subscriptions/?company_id=WrKW86", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "revision": "2024-10-15"
    },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          custom_source: isPopup ? "Newsletter Popup" : "Footer Newsletter",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email
}
            }
          }
        },
        relationships: {
          list: {
            data: { type: "list", id: "Y5wyY9" }
          }
        }
      }
    })
  }).then(function (res) {
    if (messageEl) {
      messageEl.textContent = "Mulțumim! Verifică-ți emailul pentru a confirma abonarea.";
      messageEl.classList.remove("hidden");
    }
    if (emailInput) emailInput.style.display = "none";
    if (submitBtn) submitBtn.style.display = "none";
    setCookie("newsletter-subscribed", "true");

    // Auto-close popup after 3 seconds
    if (isPopup) {
      setTimeout(function () {
        var popup = document.querySelector("newsletter-popup");
        if (popup && popup.hide) popup.hide();
      }, 3000);
    }
  }).catch(function (e) {
    console.warn("[Newsletter] Klaviyo subscribe error:", e);
    if (submitBtn) submitBtn.disabled = false;
  });
});

/* ═══════════════════════════════════════════════════
   MARQUEE LINK → OPEN NEWSLETTER POPUP
   Catches clicks on #open-newsletter-popup anchors
   ═══════════════════════════════════════════════════ */
document.addEventListener("click", function (e) {
  var link = e.target.closest('a[href="#open-newsletter-popup"]');
  if (!link) return;
  e.preventDefault();
  var popup = document.querySelector("newsletter-popup");
  if (popup && popup.show) popup.show();
});
